import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../lib/api";
import { Logo, LangToggle } from "../../components/marketing/Navbar";
import GoogleButton from "../../components/marketing/GoogleButton";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", company_name: "", tin: "", cr_number: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(f);
      toast.success(t("register_title"));
      nav("/app/onboarding");
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex gc-gradient-navy text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 gc-hero-grid opacity-30" />
        <div className="relative"><Logo light /></div>
        <div className="relative">
          <h2 className="font-display text-3xl font-bold leading-tight">{t("secondary_pos")}</h2>
          <p className="mt-4 text-white/70 max-w-md">{t("register_sub")}</p>
        </div>
        <div className="relative text-xs text-white/40">{t("footer_copy")}</div>
      </div>
      <div className="flex flex-col p-6 sm:p-12">
        <div className="flex justify-between items-center">
          <div className="lg:hidden"><Logo /></div>
          <div className="ms-auto"><LangToggle /></div>
        </div>
        <form onSubmit={submit} className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto py-8">
          <h1 className="font-display text-3xl font-bold text-[hsl(217_63%_15%)]">{t("register_title")}</h1>
          <p className="mt-2 text-muted-foreground">{t("register_sub")}</p>
          <div className="mt-6"><GoogleButton /></div>
          <div className="my-5 flex items-center gap-3 text-xs text-muted-foreground"><span className="flex-1 h-px bg-border" />{t("or_sep")}<span className="flex-1 h-px bg-border" /></div>
          <div className="space-y-4">
            <div><Label>{t("full_name")}</Label><Input data-testid="reg-name" required className="mt-1.5 h-11" value={f.name} onChange={set("name")} /></div>
            <div><Label>{t("company_name")}</Label><Input data-testid="reg-company" required className="mt-1.5 h-11" value={f.company_name} onChange={set("company_name")} /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>{t("tin")}</Label><Input data-testid="reg-tin" className="mt-1.5 h-11" value={f.tin} onChange={set("tin")} /></div>
              <div><Label>{t("cr_number")}</Label><Input data-testid="reg-cr" className="mt-1.5 h-11" value={f.cr_number} onChange={set("cr_number")} /></div>
            </div>
            <div><Label>{t("phone")}</Label><Input data-testid="reg-phone" className="mt-1.5 h-11" placeholder="05xxxxxxxx" value={f.phone} onChange={set("phone")} /></div>
            <div><Label>{t("email")}</Label><Input data-testid="reg-email" type="email" required className="mt-1.5 h-11" value={f.email} onChange={set("email")} /></div>
            <div><Label>{t("password")}</Label><Input data-testid="reg-password" type="password" required className="mt-1.5 h-11" value={f.password} onChange={set("password")} /></div>
          </div>
          <Button data-testid="reg-submit" disabled={loading} className="mt-7 h-11 rounded-full bg-[hsl(158_64%_28%)] hover:bg-[hsl(158_64%_24%)]">{loading ? t("loading") : t("sign_up")}</Button>
          <p className="mt-5 text-sm text-muted-foreground text-center">{t("have_account")} <Link to="/login" className="text-[hsl(158_64%_28%)] font-medium">{t("sign_in")}</Link></p>
        </form>
      </div>
    </div>
  );
}
